<template>
    <div class="system-search-options">
        <amf-checkbox class="mr-1" label="Participants" v-if="participantSearchVisible" v-model="searchParticipants" />
        <amf-checkbox class="mr-1" label="Employers" v-if="employerSearchVisible" v-model="searchEmployers" />
        <amf-checkbox class="mr-1" label="Broker Entities" v-if="brokerSearchVisible" v-model="searchBrokers" />
    </div>
</template>

<script>
    function getItem(key, defaultValue = {}) {
        let data = localStorage.getItem(key);
        if(data) {
            return JSON.parse(data);
        }
        else {
            localStorage.setItem(key, JSON.stringify(defaultValue));
            return defaultValue;
        }
    }

    function setItem(key, data) {
        localStorage.setItem(key, JSON.stringify(data));
    }

    function moreThanOneUniqueEmployer(employers) {
        if (_.every(employers, { employerId: null })) return true;
        return _.uniq(employers.map(e => e.employerId)).length > 1;
    }

    export default {
        data() {
            return {
                searchParticipants: true,
                searchEmployers: true,
                searchBrokers: true,
                visibility: [],
                amfOptions: { noTracking: true },
            }
        },
        computed: {
            ...amfx.map('session', 'userId,employers,roles'),
            defaults() {
                let defaultSearchOptions = {
                    broker: {
                        participant: {
                            value: true,
                            visible: true
                        },
                        employer: {
                            value: true,
                            visible: () => moreThanOneUniqueEmployer(this.employers)
                        },
                        broker: {
                            value: false,
                            visible: false
                        }
                    },
                    employer: {
                        participant: {
                            value: true,
                            visible: () => moreThanOneUniqueEmployer(this.employers)
                        },
                        employer: {
                            value: false,
                            visible: () => moreThanOneUniqueEmployer(this.employers)
                        },
                        broker: {
                            value: false,
                            visible: false
                        }
                    },
                    msr: {
                        participant: {
                            value: true,
                            visible: true
                        },
                        employer: {
                            value: false,
                            visible: true
                        },
                        broker: {
                            value: false,
                            visible: true
                        }
                    },
                    internal: {
                        participant: {
                            value: true,
                            visible: true
                        },
                        employer: {
                            value: true,
                            visible: true
                        },
                        broker: {
                            value: true,
                            visible: true
                        }
                    },
                }

                defaultSearchOptions.producersupport = defaultSearchOptions.broker;
                return defaultSearchOptions;
            },
            employerSearchVisible() {
                return this.visibility.includes('employer');
            },
            brokerSearchVisible() {
                return this.visibility.includes('broker');
            },
            participantSearchVisible() {
                return this.visibility.includes('participant');
            },
        },
        created () {
            let searchOptions = getItem('searchOptions');
            let defaults = this.defaults.internal;

            for(var role of this.roles) {
                let d = this.defaults[role];
                if(d) {
                    defaults = d;
                    break;
                }
            }

            Object.keys(defaults).forEach((key) => {
                var visible = defaults[key].visible;

                if(_.isFunction(defaults[key].visible)) {
                    visible = defaults[key].visible();
                }

                if(visible) {
                    this.visibility.push(key)
                }

            });

            if(!searchOptions[this.userId]) {
                searchOptions[this.userId] = {
                    searchParticipants: defaults.participant.value,
                    searchEmployers: defaults.employer.value,
                    searchBrokers: defaults.broker.value
                }

                setItem('searchOptions', searchOptions);
            }
            this.searchParticipants = searchOptions[this.userId].searchParticipants;
            this.searchEmployers = searchOptions[this.userId].searchEmployers;
            this.searchBrokers = searchOptions[this.userId].searchBrokers;
        },
        watch: {
            '$data': {
                handler: function(newValue, oldValue) {
                    let item = getItem('searchOptions');
                    item[this.userId] = newValue;
                    setItem('searchOptions', item);
                    this.$emit('searchOptions', newValue);
                },
                deep: true
            },

        },
        methods: {
        },
    }
</script>

<style lang="scss" scoped>
    .system-search-options {
        padding: 0.25rem;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        font-size: 90%;

        .custom-checkbox { margin-right: 1rem; }
    }
</style>



// WEBPACK FOOTER //
// src/framework/primitives/SystemSearchOptions.vue